(function($, window, document) {
	
	window.blocks = {
		
		setup: function() {
			this.carouselItem();
			this.customFlickityNavigation();
			this.initLoad();
			this.teamMember();
		},

		teamMember: function() {
			$('.team-members_bio-trigger').on('click', function(e) {
				$(this).next().slideToggle();
				$(this).parent().toggleClass('active');
			});
		},
		carouselItem: function() {
              $( ".city-reporter-carousel-item" ).on('mouseenter', function(e) {

					var x = e.pageX - $(this).offset().left;
					var y = e.pageY - $(this).offset().top;

					$(this).find('.city-reporter-carousel-item_clip').css( "clip-path", "circle(400px at " + x + "px " + y + "px)" );

				});

              $( ".city-reporter-carousel-item" ).on('mouseleave', function(e) {
              		var x = e.pageX - $(this).offset().left;
					var y = e.pageY - $(this).offset().top;
              		$(this).find('.city-reporter-carousel-item_clip').css( "clip-path", "circle(0px at " + x + "px " + y + "px)" );
              });
		},

		/**
		 * Flickity takes a sec to load, so only run the custom navigation once
		 * it's loaded
		 */
		initLoad: function() {
			$( window ).on( "load", this.customFlickityNavigation );
		},

		/**
		 * Custom Flickity navigation
		 */
		customFlickityNavigation: function() {
			
			var objs = [];

 			$('.using-custom-nav').each(function (i) {

 				slider = $(this).find('.nectar-flickity');
	            nectarflkty = Flickity.data( slider[0] );

	            // load the flickity instance for the current slider in the loop into an array
	            objs[i] = nectarflkty;

	            if (objs[i]) {

	                $(this).find('.next-slide-flk').on( 'click', function() {
	                      objs[i].next();
	                });

	                $(this).find('.prev-slide-flk').on( 'click', function() {
	                    objs[i].previous();
	                });
	            }

            });
        


		}

	};

})(window.jQuery, window, document); // End of jQuery wrapper



